import { Component, OnInit, ViewChild } from '@angular/core';
import { RolesComponent } from '../roles/roles.component';
import { PremissionsComponent } from '../premissions/premissions.component';

@Component({
  selector: 'app-assignments',
  templateUrl: './assignments.component.html',
  styleUrls: ['./assignments.component.css']
})
export class AssignmentsComponent implements OnInit {

  @ViewChild(RolesComponent) cmpRoles: RolesComponent;
  @ViewChild(PremissionsComponent) cmpPermissions: PremissionsComponent;
  SelectTab: string
  Tabs: string[]

  constructor() { }

  ngOnInit(): void {
    this.SelectTab= 'Roles'
    this.Tabs = ['Roles', 'Permisos']
  }

  LoadTab(Tab: string){
    if(Tab == "Roles")
      this.cmpRoles.onLoad();
    if(Tab == "Permisos")
      this.cmpPermissions.onLoad();
  }

}
